import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=a9185d4e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=a9185d4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9185d4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9185d4e')) {
      api.createRecord('a9185d4e', component.options)
    } else {
      api.reload('a9185d4e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=a9185d4e&scoped=true&", function () {
      api.rerender('a9185d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-203ngpnSk8sy9/JS/comp/DocBox.vue"
export default component.exports